class Video {
    constructor() {
        this.addListeners();
        this.addMobileListeners();
        this.modal();
    }

    modal() {
        
        const ebModal = document.getElementById('mySizeChartModal');

        if (ebModal) {

            const saveThis = this;
            
            var ebBtn = document.getElementById("videoPlay");
            var ebSpan = document.getElementsByClassName("ebcf_close")[0];

            if (ebBtn) {
                ebBtn.onclick = function() {
                    ebModal.style.display = "block";
                }
            }

            ebSpan.onclick = function() {
                ebModal.style.display = "none";
                saveThis.clearUrl();
            }
            window.onclick = function(event) {
                if (event.target == ebModal) {
                    ebModal.style.display = "none";
                    saveThis.clearUrl();
                }
            }
        }


    }

    addListeners() {    
        
        const controls = document.getElementById('videoControls');

        if (controls) {
            const videos = document.querySelectorAll('.storys-video__content');
            const left = document.getElementById('videoLeft');
            const right = document.getElementById('videoRight');
            const play = document.getElementById('videoPlay');
            let active = 0;

            left.addEventListener('click', () => {

                videos.forEach(video => {
                    if (!video.classList.contains('storys-video__content--hidden')) {
                        active = video.dataset.id;
                    }
                })

                this.switchLeft(active, videos.length);

            })
            right.addEventListener('click', () => {

                videos.forEach(video => {
                    if (!video.classList.contains('storys-video__content--hidden')) {
                        active = video.dataset.id;
                    }
                })
                
                this.switchRight(active, videos.length);
            })

        }

    }

    addMobileListeners() {
        const controls = document.querySelectorAll('.controls-modal__item');

        if (controls) {           

            controls.forEach(control => {
                control.addEventListener('click', (e) => {
                    if (e.target.classList.contains('controls-modal__checked')) {
                  
                    } else {
                        this.switchById(e.target.dataset.id);
                    }
                    
                })
            })

        }
    }
    
    switchById(id) {
        const videos = document.querySelectorAll('.storys-video__content');
        const controls = document.querySelectorAll('.controls-modal__item');

        videos.forEach(video => {

            if(video.dataset.id == id) {
                video.classList.remove('storys-video__content--hidden');
            } else {
                video.classList.add('storys-video__content--hidden');
            }

        })

        controls.forEach(control => {
            if(control.dataset.id == id) {
                control.classList.add('controls-modal__checked');
            } else {
                control.classList.remove('controls-modal__checked');
            }
        })
    }

    switchLeft(active, length) {
        const videos = document.querySelectorAll('.storys-video__content');
        let newVideo = 0;

        if (active == 0) {
            newVideo = +length - 1;
        } else {
            newVideo = +active - 1;
        }

        videos.forEach(video => {
            if (video.dataset.id == newVideo) {
                video.classList.remove('storys-video__content--hidden');
                const url = video.dataset.url;
                this.changeUrl(url);
            } else {
                video.classList.add('storys-video__content--hidden');
            }
        })
    }

    switchRight(active, length) {
        const videos = document.querySelectorAll('.storys-video__content');
        let newVideo = 0;

        if (active == (+length - 1)) {
            newVideo = 0;
        } else {
            newVideo = +active + 1;
        }

        this.changeUrl(newVideo);

        videos.forEach(video => {
            if (video.dataset.id == newVideo) {
                video.classList.remove('storys-video__content--hidden');
                const url = video.dataset.url;
                this.changeUrl(url);
            } else {
                video.classList.add('storys-video__content--hidden');
            }
        })
    }

    changeUrl(url) {
        const youtube = document.getElementById('activeVideo');

        if (youtube) {
            youtube.src = 'https://www.youtube.com/embed/' + url;
        }
    }

    clearUrl() {
        const youtube = document.getElementById('activeVideo');

        if (youtube) {
            let saveUrl = youtube.src;
            youtube.src = '';
            youtube.src = saveUrl;
        }
    }

}

export default Video